import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { Config } from '../../config/config';

import {GralMon} from '../../entity/GralMon';

@Injectable({
  providedIn: 'root'
})
export class CuentasBancariasService {

  dataUrl = Config.URL_BASE;

  constructor(
    private http: HttpClient
  ) { }

  catalogo(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/ctaBancaria/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  post(dto: CtaBancaria): Observable<any> {
    let url_ = this.dataUrl + '/ctaBancaria/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/ctaBancaria/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  put(dto: CtaBancaria): Observable<any> {
    let url_ = this.dataUrl + '/ctaBancaria/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  /*getMonedas(): Observable<any> {
    let url_ = this.dataUrl + '/ctaBancaria/monedas';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }*/

  getMonedas(clave: String): Observable<any> {
    let url_ = '';
    if (clave !== '') {
      url_ = this.dataUrl + '/ctaBancaria/get/monedas/' + clave;
    } else {
      url_ = this.dataUrl + '/ctaBancaria/get/monedas/0';
    }
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getBancos(titulo: String): Observable<any> {
    let url_ = '';
    if (titulo !== '') {
      url_ = this.dataUrl + '/ctaBancaria/get/banco/' + titulo;
    } else {
      url_ = this.dataUrl + '/ctaBancaria/get/banco/0';
    }
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getCuentas(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/cta/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getCuenta(id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctaBancaria/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

}

export class CtaBancaria {
  id: number;
  noCuenta: String;
  nomCuenta: String;
  banco: Banco;
  gralMon: GralMon;
  gralUsrCreaId: number;
  gralUsrActualizaId: number;
  gralUsrBajaId: number;
  cuent: Cuenta;
  banc: String;
  empId: number;
  mon: String;
  mn: number;
}

export class Banco {
  id: number;
  titulo: String;
  descripcion: String;
}

export class Cuenta {
  id: number;
  cuenta: String;
  nombre: String;
}

/*export class GralMon {
  id: number;
  simbolo: String;
  claveS: String;
}*/

export class PageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
}
